<template>
    <div>
        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">{{ datosDetalle.titulo }}</h1>
            </div>
            <hr size=7 color="#FF6699">
        </div>    
        <div>
            <DataTable :value="datosDetalle.detalles" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown":rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" :loading="loading" :filters.sync="filtros">
                <template #header>
                    <div class="flex justify-content-center flex-wrap card-container">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtros['global'].value" placeholder="Buscar" />
                        </span>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button v-if="slotProps.data.tipo === 'R'" icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalles'" @click="OpenDialogDetalles()" />
                    </template>
                </Column>
                <Column field="serie" header="Serie" :styles="{'width':'5rem', 'min-width':'5rem'}"></Column>
                <Column field="folio" header="Folio" :styles="{'width':'5rem', 'min-width':'5rem'}"></Column>
                <Column field="rfc" header="RFC" :styles="{'width':'10rem', 'min-width':'10rem'}"></Column>
                <Column field="nombre" header="Nombre" :styles="{'width':'20rem', 'min-width':'20rem'}"></Column>
                <Column field="fechaPago" header="Fecha Pago" :styles="{'width':'15rem', 'min-width':'15rem'}">
                    <template #body="slotProps">
                        <span>{{ formatDate(slotProps.data.fechaPago) }}</span>
                    </template></Column>
                <Column field="puesto" header="Puesto" :styles="{'width':'20rem', 'min-width':'20rem'}"></Column>
                <Column field="clave" header="Clave" :styles="{'width':'15rem', 'min-width':'15rem'}"></Column>
                <Column field="concepto" header="Concepto" :styles="{'width':'20rem', 'min-width':'20rem'}"></Column>
                <Column field="importe" header="Importe" :styles="{'width':'10rem', 'min-width':'10rem'}">
                    <template #body="slotProps">
                        <span>{{ formatCurrency(slotProps.data.importe) }}</span>
                    </template></Column>
                </Column>
                <Column field="folioFiscal" header="Folio Fiscal" :styles="{'width':'30rem', 'min-width':'20rem'}"></Column>
            </DataTable>
        </div>

        <div>
            <hr size=7 color="#FF6699">
            <br>
            <h2> {{ sumaImportes }} </h2>
        </div>
        </div>
    </div>
    </template>
    <script>
        import axios from 'axios'
        import moment from 'moment'
        import configMil from './ReporteMilConfig.vue'
        import { FilterMatchMode, FilterOperator } from "primevue/api/"
    
        export default {
            components: {
                configMil,
            },
            data() {
                return {
                    filtros: {
                        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    },
                    loading: false,
                }
            },
            computed: {
                token() {
                    return this.$store.state.usuario;
                },
                datosDetalle(){
                    return this.$store.state.reporteMilDet;
                },
                sumaImportes(){
                    // console.log(reporteMilDet)
                    let tabla = this.$store.state.reporteMilDet.detalles;
                    let suma = tabla.reduce((acumulador, objeto) => acumulador + objeto.importe, 0);
                    let resultado = this.formatCurrency(suma);
                    return resultado;
                },
                
            },
            created() {
    
            },
            methods: {
                formatDate(value) {
                    moment.locale('es-mx');
                    return moment(value).format('DD-MMMM-YYYY')
                },

                formatCurrency(value) {
                    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                },

                cierraVentana(){
                    this.$emit('closeDialogDetalles')
                },            
            },
        }
    </script>